export default "__VITE_ASSET__BF$hQzWB__"